import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { isFalsy, isTruthy } from 'lib/Helpers';

import * as styles from './Tabs.scss';

/**
 * Reusable Tabs Component
 * @function Tabs
 * @param {Object} props
 * @return {ReactElement}
 */
const Tabs = ({ children, className, currentTab, tabData, style }) => {
  const tabs = tabData.map(tab => {
    return (
      <div
        className={classNames(
          styles.tab,
          tab.className,
          { [styles.activeTab]: (tab.key ?? tab.text.toUpperCase()) === currentTab },
          { [styles.disabledTab]: isTruthy(tab.disabled) },
        )}
        key={tab.text}
        onClick={isFalsy(tab.disabled) ? tab.onClick : null}
        style={tab.style}
      >
        {tab.text}
      </div>
    );
  });

  return (
    <div className={classNames(styles.tabsContainer, className)} style={style}>
      <div className={styles.tabs}>{tabs}</div>
      {children && <div className={styles.childrenContainer}>{children}</div>}
    </div>
  );
};

Tabs.propTypes = {
  currentTab: PropTypes.string.isRequired,
  tabData: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      onClick: PropTypes.func,
      style: PropTypes.objectOf(
        PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
      ),
      text: PropTypes.string,
    }),
  ).isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default Tabs;
